import Journal from '../views/journal/Index.vue';

import JournalConstructions from '../views/journal/constructions/Index.vue';
import JournalViewEditConstruction from '../views/journal/constructions/ViewEdit.vue';

import JournalPosts from '../views/journal/posts/Index.vue';
import JournalViewEditPost from '../views/journal/posts/ViewEdit.vue';

import JournalTeams from '../views/journal/teams/Index.vue';
import JournalViewEditTeam from '../views/journal/teams/ViewEdit.vue';

export default [
  {
    path: '/jornal',
    name: 'journal',
    component: Journal,
    children: [
      {
        path: '/jornal/obras',
        name: 'journal-constructions',
        component: JournalConstructions,
      },
      {
        path: '/jornal/obras/:id',
        props: true,
        name: 'journal-view-edit-construction',
        component: JournalViewEditConstruction,
      },
      {
        path: '/jornal/obras/:id/post/:postId',
        props: true,
        name: 'journal-view-edit-post',
        component: JournalViewEditPost,
      },
      {
        path: '/jornal/equipes',
        name: 'journal-teams',
        component: JournalTeams,
      },
      {
        path: '/jornal/equipes/:id',
        props: true,
        name: 'journal-view-edit-team',
        component: JournalViewEditTeam,
      },
      {
        path: '/jornal/posts',
        name: 'journal-posts',
        component: JournalPosts,
      },
    ],
  },
];
